mainApp.component('macCsvAuthentication', {
    templateUrl: '/public/components/mac-csv-authentication.component.html',
     bindings: {
        model: '=',
        changesListener: '&'
     },
     controller: ['$scope', '$state', function($scope, $state) {
         const ctrl = this;

         ctrl.handleServerResponse = function (serverResponse) {
             if (serverResponse.status && serverResponse.status === "OK") {
                 ctrl.currentFileStatus = serverResponse.data.fileInfo;
                 ctrl.currentFileError = false;
             } else if (serverResponse.status && serverResponse.status === "ERROR") {
                 ctrl.currentFileStatus = serverResponse.notifications[0].message;
                 ctrl.currentFileError = true;
             }
         }

         ctrl.$onInit = function() {
             store.fetch({
                 method : 'GET',
                 url : '/macAddressAuth/getInfo',
                 queryParams: {
                     accountId: $state.params.accountId
                 },
                 success: ctrl.handleServerResponse
             });

             ctrl.hasChanges = false;
             if (!ctrl.model.timeTrafficAllowedForHostInterval){
                 ctrl.model.timeTrafficAllowedForHost = 12;
                 ctrl.model.timeTrafficAllowedForHostInterval = "HOURS";
             }
             if (!ctrl.model.timeTrafficRejectedForHostInterval){
                 ctrl.model.timeTrafficRejectedForHost = 1;
                 ctrl.model.timeTrafficRejectedForHostInterval = "HOURS";
             }

             reload();
         }

         ctrl.selectCsvFile = function() {
             var input = $(document.createElement('input'));
             input.attr("type", "file");
             input.trigger('click');

             input.change(function(event) {
                 const file = event.target.files[0];

                 const formData = new FormData();
                 formData.append('accountId', $state.params.accountId);
                 formData.append('file', file);

                 store.uploadFile({
                     url: "/macAddressAuth/upload",
                     method: "POST",
                     file: formData,
                     contentType: 'multipart/form-data',
                     success: ctrl.handleServerResponse
                 });
             });
         }

         ctrl.downloadCsvFile = function() {
             window.location = "/macAddressAuth/download?&accountId=" + $state.params.accountId;
         }

         ctrl.periodTypes = [
             {display:"Hours", value:"HOURS"},
             {display:"Days", value:"DAYS"}];

         ctrl.$doCheck = function() {
             if (!ctrl.changesListener)
                 return;

             var isChangedNow = !angular.equals(ctrl.model, ctrl.original);

             //check if listener was already called and updates about having changes
             if (ctrl.hasChanges === isChangedNow)
                 return;

             ctrl.hasChanges = isChangedNow;
             ctrl.changesListener({
                 isDirty: ctrl.hasChanges,
                 componentName: 'macAddressAuthentication'
             });
         }

         $scope.$on('modelReloadedEvent', function (event, data) {
             reload();
         });

         function reload() {
             ctrl.original = angular.copy(ctrl.model);
         }
     }]
});
